import { useEffect, useState } from 'react';
import AppIcon from '../AppIcon';

const TYPE_CONFIG = {
  success: { icon: 'CheckCircle2', iconColor: '#16a34a', bg: '#f0fdf4', border: '#bbf7d0' },
  error:   { icon: 'XCircle',      iconColor: '#dc2626', bg: '#fef2f2', border: '#fecaca' },
  warning: { icon: 'AlertTriangle',iconColor: '#d97706', bg: '#fffbeb', border: '#fde68a' },
  info:    { icon: 'Info',         iconColor: '#2563eb', bg: '#eff6ff', border: '#bfdbfe' },
};

const Toast = ({ notification, type, message, onClose, duration = 3000 }) => {
  const [visible, setVisible] = useState(false);

  const resolved = notification
    ? {
        message: notification.message,
        icon: notification.icon,
        iconColor: notification.iconColor,
        bg: '#ffffff',
        border: '#e2e8f0',
      }
    : type
    ? { message, ...TYPE_CONFIG[type] }
    : null;

  useEffect(() => {
    if (!resolved) return;
    // تأخير بسيط لتشغيل الانيميشن
    const show = requestAnimationFrame(() => setVisible(true));
    const hide = setTimeout(() => {
      setVisible(false);
      setTimeout(onClose, 300);
    }, duration);
    return () => {
      cancelAnimationFrame(show);
      clearTimeout(hide);
    };
  }, [duration]);

  if (!resolved) return null;

  return (
    <div
      dir="rtl"
      className="fixed top-0 inset-x-0 flex justify-center z-[9999] px-4 pointer-events-none"
      style={{ paddingTop: 'calc(env(safe-area-inset-top, 0px) + 16px)' }}
    >
      <div
        className="pointer-events-auto flex items-center gap-3 px-4 py-3 rounded-2xl shadow-lg border transition-all duration-300"
        style={{
          backgroundColor: resolved.bg,
          borderColor: resolved.border,
          transform: visible ? 'translateY(0) scale(1)' : 'translateY(-16px) scale(0.97)',
          opacity: visible ? 1 : 0,
          maxWidth: '420px',
          width: '100%',
        }}
      >
        <AppIcon name={resolved.icon} size={20} color={resolved.iconColor} className="flex-shrink-0" />
        <p className="text-sm font-medium text-slate-800 flex-1 leading-snug">
          {resolved.message}
        </p>
        <button
          onClick={() => { setVisible(false); setTimeout(onClose, 300); }}
          className="flex-shrink-0 p-1 rounded-lg hover:bg-black/5 transition-colors"
          aria-label="إغلاق"
        >
          <AppIcon name="X" size={14} color="#94a3b8" />
        </button>
      </div>
    </div>
  );
};

export default Toast;
